export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_17.21db413d.jpg";